import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import { ScheduleTemplateStatus } from "@common/types/domains/accounting/schedule";
import { Button } from "@design-system/Button/Button";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { HStack } from "@design-system/HStack/HStack";
import { Menu } from "@design-system/Menu/Menu.lib";

export interface ScheduleTemplateActions {
    onApply: (template: ScheduleTemplateListItem) => void;
    onEdit: (template: ScheduleTemplateListItem) => void;
    onViewApplied: (template: ScheduleTemplateListItem) => void;
    onDuplicate: (template: ScheduleTemplateListItem) => void;
    onArchive: (template: ScheduleTemplateListItem) => void;
    onRestore: (template: ScheduleTemplateListItem) => void;
    onDelete: (template: ScheduleTemplateListItem) => void;
}

interface ScheduleRowActionsCellProps extends ScheduleTemplateActions {
    template: ScheduleTemplateListItem;
    triggerClassName?: string;
}

export const ScheduleRowActionsCell: React.FC<ScheduleRowActionsCellProps> = ({
    template,
    onApply,
    onEdit,
    onViewApplied,
    onDuplicate,
    onArchive,
    onRestore,
    onDelete,
    triggerClassName,
}) => {
    const isArchived = template.status === ScheduleTemplateStatus.archived;
    return (
        <CaptureClicks>
            <HStack gap={8} align="center">
                <Button
                    variant="primary"
                    size="sm"
                    className={triggerClassName}
                    disabled={isArchived}
                    onClick={() => onApply(template)}
                >
                    Apply
                </Button>
                <Menu.More className={triggerClassName}>
                    <Menu.Item onClick={() => onEdit(template)}>
                        Edit policy
                    </Menu.Item>
                    <Menu.Item onClick={() => onViewApplied(template)}>
                        View schedules
                    </Menu.Item>
                    <Menu.Item onClick={() => onDuplicate(template)}>
                        Duplicate
                    </Menu.Item>
                    {isArchived ? (
                        <Menu.Item onClick={() => onRestore(template)}>
                            Restore
                        </Menu.Item>
                    ) : (
                        <Menu.Item onClick={() => onArchive(template)}>
                            Archive
                        </Menu.Item>
                    )}
                    <Menu.Item destructive onClick={() => onDelete(template)}>
                        Delete
                    </Menu.Item>
                </Menu.More>
            </HStack>
        </CaptureClicks>
    );
};
